// extracted by mini-css-extract-plugin
export default {"container":"EditClientBalanceModal_container__eB7Rr","modalContent":"EditClientBalanceModal_modalContent__JcF4A","errorBanner":"EditClientBalanceModal_errorBanner__qebBA"};